import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

class TradeDigitalDoubles {
  constructor(form, currencyNormalize = {}, tradingAccountPrimeBrokerNormalize = {}) {
    this.trade_type = form.trade_type.name
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.quantity = Number(form.quantity)
    if (form.trade_type.name.includes('Client') && form.side) {
      this.side = form.side === 'BUY' ? 'SELL' : 'BUY'
    } else {
      this.side = form.side
    }
    this.counterparty = form.counterparty
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.settlement_date = form.settlement_date
      ? dayjs(form.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.put_call = form.put_call
    this.fixing_source = form.fixing_source
    if (
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.fixing_date = dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE)
    }
    this.premium = Number(form.premium_amount)
    this.cut = form.cut
    this.strike = Number(form.strike)
    this.premium_date = form.premium_date
      ? dayjs(form.premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.trader_name = form.trader_name
    this.premium_currency = form.premium_currency.name
    this.payout_amount = Number(form.payout_amount)
    this.payout_currency = form.payout_currency.name
    this.spot_ref = Number(form.spot_ref)
    this.timing = form.timing
    this.note = form.note
    this.lower_barrier = Number(form.lower_barrier)
    this.upper_barrier = Number(form.upper_barrier)
    this.window_start = form.window_start
      ? dayjs(form.window_start).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.window_end = form.window_end ? dayjs(form.window_end).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.direction = form.direction
    if (
      this.counterparty &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker[form.counterparty]
        .prime_broker === 'RBS'
    ) {
      this.bdr = form.bdr
      this.is_pba = form.is_pba
      this.is_structure = form.is_structure
    }
    this.trade_origin = 'FXER'
  }
  // will work just when update
  isEqual({ trade, currencyNormalize, tradingAccountPrimeBrokerNormalize }) {
    let { trade_date } = trade
    trade_date = dayjs(trade_date).format(DATE_FORMAT.REGULAR_DATE_TIME)
    trade.trade_type = trade.type
    trade.quantity = Math.abs(trade.client_quantity) || Math.abs(trade.market_maker_quantity)
    trade.counterparty = trade.client || trade.market_maker
    trade = new TradeDigitalDoubles(trade, currencyNormalize, tradingAccountPrimeBrokerNormalize)
    trade.trade_date = trade_date
    for (const key of Object.keys(trade)) {
      if (this[key] !== trade[key]) {
        return false
      }
    }
    return true
  }
}

export default TradeDigitalDoubles
